import { render, staticRenderFns } from "./MandatoryEndorsementsViewer.vue?vue&type=template&id=b1c14bfc&scoped=true"
import script from "./MandatoryEndorsementsViewer.vue?vue&type=script&lang=ts"
export * from "./MandatoryEndorsementsViewer.vue?vue&type=script&lang=ts"
import style0 from "./MandatoryEndorsementsViewer.vue?vue&type=style&index=0&id=b1c14bfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1c14bfc",
  null
  
)

export default component.exports